import { render } from "./MBAPublicFaqView.vue?vue&type=template&id=39caba1e"
import script from "./MBAPublicFaqView.vue?vue&type=script&lang=js"
export * from "./MBAPublicFaqView.vue?vue&type=script&lang=js"

import "./MBAPublicFaqView.vue?vue&type=style&index=0&id=39caba1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__